import { Video } from '@src/interfaces/video.model';
import { Component, Host, Prop, State, h } from '@stencil/core';
import { getAltClass, getTeaserBackground, getLinkColor } from '@utils/teaser';

@Component({
  tag: 'visa-marquee',
  styleUrl: '_vs-marquee.scss',
  shadow: false,
})
export class VisaMarquee {
  @Prop() enabled: boolean;
  @Prop() marqueeID: string;

  //Teaser Props
  @Prop() teaserTheme: any;
  @Prop() teaserAlignment: string;
  @Prop() teaserEyebrowText: any;
  @Prop() teaserHeadline: string;
  @Prop() teaserSubHeadline: string;
  @Prop() headingStyle: string;
  @Prop() hasTransparentTeaser: Boolean;

  //Media Props
  @Prop() videoEnabled: boolean;
  @Prop() mobileImage: any;
  @Prop() mobileImageAlt: any;
  @Prop() desktopImage: any;
  @Prop() desktopImageAlt: any;
  @Prop() videoProps: Video;

  //Link Props
  @Prop() linkStyle: string;
  @Prop() linkColor: string;
  @Prop() linkPropColor: string;
  @Prop() linkType: string;
  @Prop() linkText: string;
  @Prop() linkVal: string;
  @Prop() linkTarget: string;
  @Prop() linkConversion: string;
  @Prop() linkAriaLabel: string;
  @Prop() linkVideoImage: string;
  @Prop() linkVideoTitle: string;
  @Prop() linkVideoImageText: string;
  @Prop() linkVideoLink: string;
  @Prop() linkVideoAriaLabel: string;
  @Prop() linkNoFollow: string;

  //LinkSub Props
  @Prop() linkStyleSub: string;
  @Prop() linkColorSub: string;
  @Prop() linkTypeSub: string;
  @Prop() linkTextSub: string;
  @Prop() linkValSub: string;
  @Prop() linkTargetSub: string;
  @Prop() linkConversionSub: string;
  @Prop() linkAriaLabelSub: string;
  @Prop() linkVideoImageSub: string;
  @Prop() linkVideoTitleSub: string;
  @Prop() linkVideoImageTextSub: string;
  @Prop() linkVideoLinkSub: string;
  @Prop() linkVideoAriaLabelSub: string;
  @Prop() linkNoFollowSub: string;

  //Accessibility props
  @Prop() accessibility?:any

  @State() btnColor: string = '';
  @State() backgroundTheme: string = '';
  @State() altClass: string = '';
  @State() theme: string;

  @State() isMobileDeviceUsed: boolean;

  private updateLinkProps() {
    this.backgroundTheme = getTeaserBackground(this.teaserTheme);
    if (this.linkPropColor == '') {
      this.linkColor = getLinkColor(this.teaserTheme,this.linkStyle);
    } else {
      this.linkColor = this.linkPropColor;
    }
    this.altClass = getAltClass(this.teaserTheme);
    this.linkColorSub = getLinkColor(this.teaserTheme,this.linkStyle);
  }

  componentDidLoad() {
    this.isMobileDeviceUsed = window.innerWidth < 992;
    window.addEventListener('resize', () => {
      this.isMobileDeviceUsed = window.innerWidth < 992;
    });
    this.updateLinkProps();
  }

  componentWillUpdate() {
    this.updateLinkProps();
  }

  render() {
    return (
      <Host>
        <div class={`vs-marquee vs-mb-0 ${this.enabled ? '' : 'vs-d-none'}`}
          id={this.marqueeID}>
          <div class={`vs-marquee-wrapper`}>
            <ul class='vs-marquee-content vs-col-12 vs-px-0'>
              <li>
                {!this.isMobileDeviceUsed &&
                  <div class='vs-marquee-item'>
                    <div style={{ zIndex: "2" }} class={`vs-marquee-content-wrapper vs-content-wrapper-padding ${this.teaserAlignment != "left" ? 'vs-right-aligned' : ''} vs-${this.backgroundTheme} ${this.hasTransparentTeaser ? 'vs-transparent' : ''}`}>
                      {this.teaserEyebrowText && (
                        <div class={`vs-lead vs-pb-2 ${this.altClass}`}>{this.teaserEyebrowText}</div>
                      )}
                      {this.teaserHeadline && this.headingStyle === 'h1' &&
                        (<h1 class={`vs-h2 ${this.altClass}`} innerHTML={this.teaserHeadline} />)}
                      {this.teaserHeadline && this.headingStyle === 'h2' &&
                        (<h2 class={`vs-h2 ${this.altClass}`} innerHTML={this.teaserHeadline} />)}
                      {this.teaserHeadline && this.headingStyle === 'h3' &&
                        (<h3 class={`vs-h2 ${this.altClass}`} innerHTML={this.teaserHeadline} />)}
                      {this.teaserHeadline && this.headingStyle === 'h4' &&
                        (<h4 class={`vs-h2 ${this.altClass}`} innerHTML={this.teaserHeadline} />)}
                      {this.teaserHeadline && this.headingStyle === 'blockquote' && (
                        <blockquote class={`vs-h2 ${this.altClass} vs-quote-h2`}
                                    innerHTML={this.teaserHeadline}>
                          {this.teaserSubHeadline && (
                            <cite class={`vs-text ${this.altClass} vs-d-block vs-pt-2`}
                                  innerHTML={this.teaserSubHeadline}/>
                          )}
                        </blockquote>
                      )}
                      {this.teaserSubHeadline && this.headingStyle !== 'blockquote' && (
                        <p class={`vs-text ${this.altClass}`} innerHTML={this.teaserSubHeadline}/>
                      )}
                      {this.linkText &&
                        <vs-link
                          linkStyle={this.linkStyle}
                          buttonColor={this.linkColor}
                          linkType={this.linkType}
                          linkText={this.linkText}
                          linkVal={this.linkVal}
                          linkTarget={this.linkTarget}
                          linkConversion={this.linkConversion}
                          linkAriaLabel={this.linkAriaLabel}
                          videoUrl={this.linkVideoLink}
                          videoTitle={this.linkVideoTitle}
                          imgPath={this.linkVideoImage}
                          isNoFollow={this.linkNoFollow}
                          hasDarkBg={this.altClass === 'vs-alt' ? 'yes' : 'no'}
                        ></vs-link>
                      }
                      {this.linkTextSub &&
                        <vs-link
                          linkStyle={this.linkStyleSub}
                          buttonColor={this.linkColorSub}
                          linkType={this.linkTypeSub}
                          linkText={this.linkTextSub}
                          linkVal={this.linkValSub}
                          linkTarget={this.linkTargetSub}
                          linkConversion={this.linkConversionSub}
                          linkAriaLabel={this.linkAriaLabelSub}
                          videoUrl={this.linkVideoLinkSub}
                          videoTitle={this.linkVideoTitleSub}
                          imgPath={this.linkVideoImageSub}
                          isNoFollow={this.linkNoFollowSub}
                          hasDarkBg={this.altClass === 'vs-alt' ? 'yes' : 'no'}
                        ></vs-link>
                      }
                    </div>
                    <vs-media
                      mediaParent="marquee"
                      mobileImage={this.mobileImage}
                      desktopImage={this.desktopImage}
                      desktopImageAlt={this.desktopImageAlt}
                      mobileImageAlt={this.mobileImageAlt}
                      videoProps={this.videoProps}
                      videoEnabled={this.videoEnabled}
                      accessibility={this.accessibility}
                    >
                    </vs-media>
                  </div>}
                {this.isMobileDeviceUsed &&
                  <div class='vs-marquee-item'>
                    <vs-media
                      mediaParent="marquee"
                      mobileImage={this.mobileImage}
                      desktopImage={this.desktopImage}
                      desktopImageAlt={this.desktopImageAlt}
                      mobileImageAlt={this.mobileImageAlt}
                      videoProps={this.videoProps}
                      videoEnabled={this.videoEnabled}
                      accessibility={this.accessibility}
                    >
                    </vs-media>
                    <div style={{ zIndex: "2" }} class={`vs-marquee-content-wrapper vs-content-wrapper-padding ${this.teaserAlignment != "left" ? 'vs-right-aligned' : ''} vs-${this.backgroundTheme}`}>
                      {this.teaserEyebrowText && (
                        <div class={`vs-lead vs-pb-1 ${this.altClass}`}>{this.teaserEyebrowText}</div>
                      )}
                      {this.teaserHeadline && this.headingStyle === '' &&
                        (<h1 class={`vs-h2 ${this.altClass}`} innerHTML={this.teaserHeadline} />)}
                      {this.teaserHeadline && this.headingStyle === 'h1' &&
                        (<h1 class={`vs-h2 ${this.altClass}`} innerHTML={this.teaserHeadline} />)}
                      {this.teaserHeadline && this.headingStyle === 'h2' &&
                        (<h2 class={`vs-h2 ${this.altClass}`} innerHTML={this.teaserHeadline} />)}
                      {this.teaserHeadline && this.headingStyle === 'h3' &&
                        (<h3 class={`vs-h2 ${this.altClass}`} innerHTML={this.teaserHeadline} />)}
                      {this.teaserHeadline && this.headingStyle === 'h4' &&
                        (<h4 class={`vs-h2 ${this.altClass}`} innerHTML={this.teaserHeadline} />)}
                      {this.teaserHeadline && this.headingStyle === 'blockquote' && (
                        <blockquote class={`vs-h2 ${this.altClass} vs-quote-h2`}
                                    innerHTML={this.teaserHeadline}>
                          {this.teaserSubHeadline && (
                            <cite class={`vs-text ${this.altClass} vs-d-block vs-pt-2`}
                                  innerHTML={this.teaserSubHeadline}/>
                          )}
                        </blockquote>
                      )}
                      {this.teaserSubHeadline && this.headingStyle !== 'blockquote' && (
                        <p class={`vs-text ${this.altClass}`} innerHTML={this.teaserSubHeadline} />
                      )}
                      {this.linkText &&
                        <vs-link
                          linkStyle={this.linkStyle}
                          buttonColor={this.linkColor}
                          linkType={this.linkType}
                          linkText={this.linkText}
                          linkVal={this.linkVal}
                          linkTarget={this.linkTarget}
                          linkConversion={this.linkConversion}
                          linkAriaLabel={this.linkAriaLabel}
                          videoUrl={this.linkVideoLink}
                          videoTitle={this.linkVideoTitle}
                          imgPath={this.linkVideoImage}
                          isNoFollow={this.linkNoFollow}
                          hasDarkBg={this.altClass === 'vs-alt' ? 'yes' : 'no'}
                        ></vs-link>
                      }
                      {this.linkTextSub &&
                        <vs-link
                        linkStyle={this.linkStyleSub}
                        buttonColor={this.linkColorSub}
                          linkType={this.linkTypeSub}
                          linkText={this.linkTextSub}
                          linkVal={this.linkValSub}
                          linkTarget={this.linkTargetSub}
                          linkConversion={this.linkConversionSub}
                          linkAriaLabel={this.linkAriaLabelSub}
                          videoUrl={this.linkVideoLinkSub}
                          videoTitle={this.linkVideoTitleSub}
                          imgPath={this.linkVideoImageSub}
                          isNoFollow={this.linkNoFollowSub}
                          hasDarkBg={this.altClass === 'vs-alt' ? 'yes' : 'no'}
                        ></vs-link>
                      }
                    </div>
                  </div>}
              </li>
            </ul>
          </div>
        </div>
      </Host>
    );
  }
}
